import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { fileManager, user } from '../../../models/admin';
import { ToasterService } from '../../../toaster.service';
import { BMApiService } from '../../../services/bm.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminApiService } from '../../../services/admin.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { UserService } from '../../../services/user.service';
import { Router } from '@angular/router';
import { UtilityService } from '../../../services/utility.service';
import * as _ from 'lodash';
import { TreeComponent } from 'angular-tree-component';
import { ContextMenuComponent } from 'ngx-contextmenu';
import Swal from 'sweetalert2';
let temp;
@Component({
  selector: 'app-file-manager',
  templateUrl: './file-manager.component.html',
  styleUrls: ['./file-manager.component.css']
})
export class FileManagerComponent implements OnInit {
  fullDirectoryList: any[] = [];
  selectedDirectoryList: any[] = [];
  selectedFullDirectoryList: any[] = [];
  selectedPathList: any[] = [];
  treeViewList: any = [];
  selectedDirectory: fileManager;
  selectedRecord: fileManager = new fileManager();
  public uploadedFiles: Array<File> = [];
  dataListTree: any;
  user: any;
  isAdmin: boolean;
  loginUserId: string = '';
  permissionType: any = 0;
  searchText: any = '';
  user_data: any = [];
  selectedUser: any = [];
  selectedPermissionUser: any = [];
  modalRef: BsModalRef;
  
  @ViewChild('CommentDialog', { static: false }) CommentDialog: TemplateRef<any>;
  @ViewChild('groupFileTree', { static: false } as any) groupFileTree: TreeComponent;
  @ViewChild(ContextMenuComponent, { static: false }) public basicMenu: ContextMenuComponent;
  @ViewChild('dirAddtemplate', { static: false }) dirAddtemplate: TemplateRef<any>;
  @ViewChild('fileAddtemplate', { static: false }) fileAddtemplate: TemplateRef<any>;
  @ViewChild('userPermissionTemplate', { static: false }) userPermissionTemplate: TemplateRef<any>;
 
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  tenantUno: any;
  constructor(public restApi: BMApiService, private toaster: ToasterService, private modalService: BsModalService, public adminService: AdminApiService, public utilityService: UtilityService, private spinner: SpinnerVisibilityService, private router: Router, private userService: UserService) {
    this.user = this.userService.getUserInfo();
    this.loginUserId = this.user.id;
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission

  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("File Manager");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }

  ngOnInit() {
    this.userService.CheckLogin();
    temp = this;
    this.loadDirectoryList();
    this.getUsers()
  }
  getUsers() {
    let inpValue = new user();
    inpValue.userUno = this.loginUserId;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getUsers(inpValue)
      .subscribe(data => {
        
        this.user_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }




  // Get dir list
  loadDirectoryList() {
    this.spinner.show();
    let inpValue = new fileManager();
    inpValue.userUno = this.loginUserId;
    this.restApi.GetFileManagerList(inpValue)
      .subscribe((data:any) => {
        
        this.fullDirectoryList = data;
        this.treeViewList = this.FormatTree(this.fullDirectoryList, undefined, undefined);
        //this.groupFileTree.treeModel.update();
        this.selectedPathList = [];
        this.selectedDirectory = this.fullDirectoryList.filter(item => item.parentId == 0)[0];
        this.selectedRecord = this.selectedDirectory;
        this.selectedRecord.selectedUser = (this.selectedRecord.selectedUser && this.selectedRecord.selectedUser != '') ? this.selectedRecord.selectedUser.toString().split(',').map(Number) : [];
        this.selectedUser = this.user_data.filter(item => this.selectedRecord.selectedUser.includes(item.userUno)); 

        this.selectedPathList.push(this.selectedDirectory);
        this.selectedDirectoryList = this.fullDirectoryList.filter(item => item.parentId == this.selectedDirectory.fileUno);
        this.selectedFullDirectoryList = this.selectedDirectoryList;
        this.spinner.hide();
      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }

  RefreshDirectory() {
    this.spinner.show();
    let inpValue = new fileManager();
    inpValue.userUno = this.loginUserId;
    this.restApi.GetFileManagerList(inpValue)
      .subscribe((data: any) => {
        
        this.fullDirectoryList = data;
        this.treeViewList = this.FormatTree(this.fullDirectoryList, undefined, undefined);
        //this.groupFileTree.treeModel.update();
        this.selectedFullDirectoryList = this.fullDirectoryList.filter(item => item.parentId == this.selectedDirectory.fileUno);
        this.selectedDirectoryList = this.selectedFullDirectoryList.filter(item => item.fileName.toLowerCase().indexOf(this.searchText.toLowerCase())>-1);
        this.spinner.hide();
      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }

  public searchDirectory() {
    this.selectedDirectoryList = this.selectedFullDirectoryList.filter(item => item.fileName.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
  }
  
  public isDownloadActionVisible(item): boolean {
    return item.isFile;
  }

  public isDeleteActionVisible(item): boolean {
    return Number(item.enteredBy) == temp.loginUserId || temp.isAdmin;
  }

  public isRenameActionVisible(item): boolean {
    return !item.isFile;
  }

  public isPermissionActionVisible(item): boolean {
    return !item.isFile && (item.permissionType == 1);
  }

  downloadFile2(item) {
    window.open(item.filePath,'_blank');
  }
  downloadFile(item) {
    let inpValue = new fileManager();
    inpValue.fileUno = item.filePath;
    inpValue.userUno = this.loginUserId;
    let name = item.fileName;
    this.spinner.show();
    this.restApi.downloadFileManagerFile(inpValue).subscribe(
      data => {
        
        this.spinner.hide();
        if (data != null) {
          
          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            window.navigator.msSaveBlob(data, name);
          }
          else //Chrome & FF
          {
            var url = window.URL.createObjectURL(data);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
          }

        }
        else {
          this.spinner.hide();
          Swal.fire('Error', 'Something went wrong', 'error');
        }
      },
      error => {
        Swal.fire('Error', 'Something went wrong', 'error')
        this.spinner.hide();
      },
      () => {
        // 'onCompleted' callback.
        this.spinner.hide();

      }
    );

  }
  setUserPermission(item) {
    this.selectedRecord = new fileManager();
    this.selectedRecord = item;
    this.selectedRecord.userUno = this.loginUserId;
    this.selectedRecord.condition = 4;
    this.selectedRecord.selectedUser = (this.selectedRecord.selectedUser && this.selectedRecord.selectedUser != '') ? this.selectedRecord.selectedUser.toString().split(',').map(Number) : [];
    this.selectedPermissionUser = this.user_data.filter(item => this.selectedRecord.selectedUser.includes(item.userUno)); 
    this.modalRef = this.modalService.show(
      this.userPermissionTemplate,
      Object.assign({}, {
        class: 'gray modal-sm',
        width: 500,
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  addNewFile() {
    this.uploadedFiles = [];
    this.modalRef = this.modalService.show(
      this.fileAddtemplate,
      Object.assign({}, {
        class: 'gray modal-sm',
        width: 500,
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  saveFile() {
    
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {

      if (this.uploadedFiles.length > 5) {
        this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload');
        return false;
      }

      let formData = new FormData();
      let isFileReadyForUpload = false;
      for (var i = 0; i < this.uploadedFiles.length; i++) {
        let allowFile = false;
        let fileName = this.uploadedFiles[i].name.toLowerCase();
        let fileSize = this.uploadedFiles[i].size;
        //Check file size
        let allowFileSize = false;
        allowFileSize = this.userService.checkFileSize(fileSize);
        if (!allowFileSize) {
          this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
          return;
        }
        //To check filee size exe  
        allowFile = this.userService.checkFileValuranabity(fileName,fileSize);
        

        if (allowFile) {
          formData.append("file", this.uploadedFiles[i]);
          isFileReadyForUpload = true;
        }
      }
      if (isFileReadyForUpload) {
        formData.append("Parent", this.selectedDirectory.fileName);
        formData.append("ParentUno", this.selectedDirectory.fileUno.toString());
        formData.append("userUno", this.loginUserId.toString());
        this.restApi.commonFileUpload(formData)
          .subscribe(data => {
            
            if (data != null && data != undefined && data != '') {
              this.toaster.show('error', 'Error', 'Something went wrong');
            }
            else {
              this.toaster.show('success', 'Success', 'File uploaded.');
              this.RefreshDirectory();
              this.selectedRecord = new fileManager();
              this.uploadedFiles = [];
              this.modalRef.hide();

            }

            this.spinner.hide();
          },
            (error) => {
              this.spinner.hide();
            }
          ).add(() => {
            this.spinner.hide();
          });
      }
      else {
        this.toaster.show('error', 'Error', 'Please select the correct formate file');
      }
    }
    else {
      this.toaster.show('error', 'Error', 'Please select the file');
    }
  }


  allowedFileExtension(fileName:string ) {
    //var strTitle = (fileName.indexOf('.') > 0) ? fileName.split('.')[1].toLowerCase() : 'unknown';
    console.log(fileName.match(/\./g).length, fileName, 'fileName . length');
    if (fileName.match(/\./g).length > 1) {
      return false;
    }
    var fileNameSplitArray = fileName.split('.');
    var strTitle = (fileName.lastIndexOf('.') > 0) ? fileNameSplitArray[fileNameSplitArray.length - 1].toLowerCase() : 'unknown';
    let returnValue = false;
     
    switch (strTitle) {
      case 'txt':
        returnValue = true;
        break;
      case 'doc':
        returnValue = true;
        break;
      case 'docx':
        returnValue = true;
        break;
      case 'xls':
        returnValue = true;
        break;
      case 'xlsx':
        returnValue = true;
        break;
      case 'pdf':
        returnValue = true;
        break;
      
      case 'jpeg':
      case 'jpg':
      case 'png':
        returnValue = true;
        break;
      case 'ppt':
      case 'pptx':
        returnValue = true;
        break;
       
      default:
        returnValue = false;
        break;
    }

    return returnValue;
  }
  renameDirectory(item) {
    this.selectedRecord = new fileManager();
    this.selectedRecord = item;
    this.selectedRecord.userUno = this.loginUserId;
    this.selectedRecord.condition = 2;
    this.selectedRecord.isFile = false;
    this.modalRef = this.modalService.show(
      this.dirAddtemplate,
      Object.assign({}, {
        class: 'gray modal-sm',
        width: 500,
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }
  addNewDirectory() {
    this.selectedRecord = new fileManager();
    this.selectedRecord.userUno = this.loginUserId;
    this.selectedRecord.condition = 1;
    this.selectedRecord.isFile = false;
    this.selectedRecord.parentId = this.selectedDirectory != undefined && this.selectedDirectory != null ? this.selectedDirectory.fileUno : 0;
    this.modalRef = this.modalService.show(
      this.dirAddtemplate,
      Object.assign({}, {
        class: 'gray modal-sm',
        width:500,
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  saveDirectory(valid) {
    
    if (valid) {
      let directoryList: any = [];
      let directoryName: any = [];
       directoryList = this.fullDirectoryList.filter(item => item.parentId == this.selectedRecord.parentId);

      if (directoryList.length > 0) {
       directoryName= directoryList.filter(item => item.fileName == this.selectedRecord.fileName);
      }

      if (directoryName.length > 0) {
        this.toaster.show('warning', 'Warning', 'Duplicate directory name is not allowed');
        return;
      }

      this.selectedRecord.selectedUser = (this.selectedRecord.selectedUser) ? this.selectedRecord.selectedUser.toString() : null;
      this.restApi.fileManagerInsertUpdate(this.selectedRecord)
        .subscribe(data => {
          
          if (data != null && data != undefined && data != '') {
            this.toaster.show('error', 'Error', 'Something went wrong');
          }
          else {
            this.toaster.show('success', 'Success', 'Directory created');
            this.RefreshDirectory();
            this.selectedRecord = new fileManager();
            this.modalRef.hide();

          }

          this.spinner.hide();
        },
          (error) => {
            this.spinner.hide();
          }
        ).add(() => {
          this.spinner.hide();
        });
    }
    else {
      this.toaster.show('error', 'Error', 'Enter the directory name');
    }
  }

  saveUsers() {
    this.selectedRecord.selectedUser = (this.selectedRecord.selectedUser && this.selectedRecord.selectedUser.length!=0) ? this.selectedRecord.selectedUser.toString() : null;
      this.restApi.fileManagerInsertUpdate(this.selectedRecord)
        .subscribe(data => {
          
          if (data != null && data != undefined && data != '') {
            this.toaster.show('error', 'Error', 'Something went wrong');
          }
          else {
            this.toaster.show('success', 'Success', 'Directory/File users saved.');
            this.RefreshDirectory();
            this.selectedRecord = new fileManager();
            this.modalRef.hide();

          }

          this.spinner.hide();
        },
          (error) => {
            this.spinner.hide();
          }
        ).add(() => {
          this.spinner.hide();
        });
  
  
  }
  deleteDirectoryFile(item) {
    Swal.fire({
      title: 'Delete',
      text: 'Please confirm to delete',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.deleteFile(item);
      }
      else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    })
  }

  deleteFile(item) {
    let inpValue = new fileManager();
    inpValue = item;
    inpValue.userUno = this.loginUserId;
    inpValue.condition = 3;
    this.restApi.fileManagerInsertUpdate(inpValue)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          this.toaster.show('success', 'Success', 'Directory File deleted.');
          this.RefreshDirectory();
        }

        this.spinner.hide();
      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }

  openFolder(item) {
    this.selectedDirectory = item;
    this.selectedPathList.push(item);
    this.selectedPathList = _.uniqBy(this.selectedPathList, 'fileUno');
    this.selectedDirectoryList = this.fullDirectoryList.filter(item => item.parentId == this.selectedDirectory.fileUno);
    this.selectedRecord = item;
    this.selectedRecord.selectedUser = (this.selectedRecord.selectedUser && this.selectedRecord.selectedUser != '') ? this.selectedRecord.selectedUser.toString().split(',').map(Number) : [];
    this.selectedUser = this.user_data.filter(item => this.selectedRecord.selectedUser.includes(item.userUno)); 
  }
  openLink(item,index) {
    this.selectedDirectory = item;
    this.selectedPathList = this.selectedPathList.filter((i, idx)=>idx<=index);
    this.selectedDirectoryList = this.fullDirectoryList.filter(item => item.parentId == this.selectedDirectory.fileUno);
    this.selectedRecord = item;
    this.selectedRecord.selectedUser = (this.selectedRecord.selectedUser && this.selectedRecord.selectedUser != '') ? this.selectedRecord.selectedUser.toString().split(',').map(Number) : [];
    this.selectedUser = this.user_data.filter(item => this.selectedRecord.selectedUser.includes(item.userUno));

  }
  FormatTree(array, parent, tree) {

    var temp = this;
    tree = typeof tree !== 'undefined' ? tree : [];
    parent = typeof parent !== 'undefined' ? parent : { fileUno: 0 };

    var children = _.filter(
      array, function (child) {
        return child.parentId == parent.fileUno;
      }
    );

    if (!_.isEmpty(children)) {
      if (parent.fileUno == 0) {
        tree = children;
      } else {
        parent['children'] = children
      }
      _.each(children, function (child) { temp.FormatTree(array, child, tree) });

    }
    this.dataListTree = tree;
    setTimeout(() => this.dataListTree = this.process(tree), 1500);
    return tree;
  }
  private process(data): any {

    let result = [];
    result = data.map((item) => {
      return this.toTreeNode(item);
    });
    return result;
  }

  private toTreeNode(node) {
    if (node && node.children) {
      node.children.map(item => {
        return this.toTreeNode(item);
      });
    }
    return node;
  }


  checkFileType(fileName) {
    //file type extension
    let checkFileType = fileName.split('.').pop();
    var fileType;
    if (checkFileType == "txt") {
      fileType = "fa-file-text";
    }
    else if (checkFileType == "pdf") {
      fileType = "fa-file-pdf-o";
    }
    else if (checkFileType == "doc" || checkFileType == "docx") {
      fileType = "fa-file-word-o";
    }
    else if (checkFileType == "pptx" || checkFileType == "ppt") {
      fileType = "fa-file-powerpoint-o";
    }
    else if (checkFileType == "xls" || checkFileType == "xlsx") {
      fileType = "fa-file-excel-o";
    }
    else if (checkFileType == "png") {
      fileType = "fa-file-image-o";
    }
    else if (checkFileType == "jpg") {
      fileType = "fa-file-image-o";
    }
    else if (checkFileType == "jpeg") {
      fileType = "fa-file-image-o";
    }
    else if (checkFileType == "gif") {
      fileType = "fa-file-video-o";
    }
    else if (checkFileType == "csv") {
      fileType = "fa-file-o";
    }
    else if (checkFileType == 'mp4' || checkFileType == 'm4a') {
      fileType = "fa-file-video-o";
    }
    else if (checkFileType == 'zip' || checkFileType == 'rar') {
      fileType = " fa-file-zip-o";
    }
    else {
      fileType = " fa-file";
    }
   
    return fileType;
  }

}
